import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const ShareFinancesSeparateShared: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG
            width="45px"
            height="29px"
            viewBox="0 0 45 29"
            fill="none"
            {...props}
        >
            <circle
                cx="13.907"
                cy="14.4324"
                r="13.6258"
                fill="#CF7135"
                style={{ fill: 'color(display-p3 0.8118 0.4431 0.2078)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
            <g style={{ mixBlendMode: 'multiply' }}>
                <circle
                    cx="31.3719"
                    cy="14.4324"
                    r="13.6258"
                    fill="#6DBBF3"
                    style={{ fill: 'color(display-p3 0.4275 0.7333 0.9529)' }}
                    fillOpacity={1}
                    strokeWidth={0}
                />
            </g>
        </IconSVG>
    );
};
